export default __webpack_public_path__ + "static/team1-124d08f40add771d7fa5274deb27dfab.jpg";